import { render, staticRenderFns } from "./add-human.vue?vue&type=template&id=3a7ee5e8&scoped=true&lang=pug"
import script from "./add-human.js?vue&type=script&lang=js&external"
export * from "./add-human.js?vue&type=script&lang=js&external"
import style0 from "./add-human.vue?vue&type=style&index=0&id=3a7ee5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ee5e8",
  null
  
)

export default component.exports